import { Animation } from "@nocios/presentation-kit";
import { useSelector } from "react-redux";
import Config from "src/Constants/Config";
import store from "src/Reducers/store";
import setCurrentPage from "src/Utils/setCurrentPage";
import ExtraDescription from "src/Component/ExtraDescription";

const PageId = 4;
const BackPageId = PageId - 1;
const NextPageId = PageId + 1;

const DATA = () => {
  const currentPage = useSelector(() => store.getState().appReducer.currentPage);
  const baseImageUrl = `${Config.BASE_URL}/images/screen_${PageId}/`;

  const DATA_IMAGES = [
    {
      image: `${baseImageUrl}animation_1.png`,
      effect: "animate-up",
      imageStyle: { width: "var(--width-1739)", right: "var(--height-5)", top: 0 },
    },
    {
      image: `${baseImageUrl}animation_2.png`,
      effect: "animate-up",
      imageStyle: { width: "var(--width-1739)", right: "var(--height-5)", top: 0 },
    },
    {
      image: `${baseImageUrl}animation_3.png`,
      effect: "animate-up",
      imageStyle: { width: "var(--width-1739)", right: "var(--height-5)", top: 0 },
    },
    {
      image: `${baseImageUrl}animation_4.png`,
      effect: "animate-up",
      imageStyle: { width: "var(--width-1739)", right: "var(--height-5)", top: 0 },
    },
  ];

  const times = [600, 600, 600, 600, 500, 600];

  const backButtonConfig = {
    label: "Back",
    type: "back",
    startIcon: { icon: "arrow-right", color: "#fff" },
    onClick: () => setCurrentPage(BackPageId),
    style: { gap: "var(--width-16)" },
  };

  const nextButtonConfig = {
    label: "Next",
    type: "next",
    endIcon: { icon: "arrow-left" },
    onClick: () => setCurrentPage(NextPageId),
    style: { gap: "var(--width-16)" },
  };

  return {
    bgVideo: {
      video: `${Config.BASE_URL}/videos/bg_${PageId}.mp4`,
      poster: `${Config.BASE_URL}/images/BG/bg_${PageId}.jpg`,
    },
    title: "Stay ahead of problems with\nproactive monitoring.",
    description: `Simulate notifications for bandwidth congestion\nor device errors, along with AI-recommended\nsolutions.`,
    leftAfterDescription: (
      <ExtraDescription
        text={`Key Features:<ul>\n<li>Smart Notifications: Get instant alerts for\nnetwork congestion, device errors, or unusual\nactivity.</li>\n<li>AI-Driven Solutions: Receive actionable\nrecommendations to resolve issues swiftly and\nefficiently.</li>\n<li>Customer-Centric Approach: Improve\nreliability and reduce downtime, enhancing\noverall satisfaction.</li></ul>`}
      />
    ),
    rightSideComponent: <Animation times={times} pageNumber={PageId} currentPage={currentPage} images={DATA_IMAGES} />,

    back: backButtonConfig,
    next: nextButtonConfig,
  };
};

export default DATA;
